import type { TFunction } from 'i18next';
import { ValidationResultLabels } from './ValidationResultScreen';

const RESULT = 'tenantsAssociation.validationResult';

/**
 * `allRejected` distinguishes the two outcomes that share this screen: a partial
 * batch that did start (some tenants skipped) from one where every tenant failed
 * and nothing is running. Only the first has logs worth opening.
 */
export const buildValidationResultLabels = (
  t: TFunction,
  { allRejected }: { allRejected: boolean }
): ValidationResultLabels => ({
  title: t(allRejected ? `${RESULT}.TITLE_NONE` : `${RESULT}.TITLE_PARTIAL`),
  body: t(allRejected ? `${RESULT}.BODY_NONE` : `${RESULT}.BODY_PARTIAL`),
  batchId: t(`${RESULT}.BATCH_ID`),
  willMigrateCount: t(`${RESULT}.WILL_MIGRATE_COUNT`),
  skippedCount: t(`${RESULT}.SKIPPED_COUNT`),
  willMigrateTitle: t(`${RESULT}.WILL_MIGRATE_TITLE`),
  skippedTitle: t(`${RESULT}.SKIPPED_TITLE`),
  actionLabel: t(allRejected ? `${RESULT}.CLOSE` : `${RESULT}.VIEW_LOGS`)
});
